import { API_BASE } from '@/lib/constants'
import type { TenantUser } from '@/types/user'

/** Admin SPA `public/logo` — backend/public/logo ile senkron. */
export const PLATFORM_LOGO = {
  avatar: '/logo/CodexFix.jpg',
  horizontalLight: '/logo/Yatay.png',
  horizontalDark: '/logo/Yatay_beyaz.png',
  verticalLight: '/logo/Dikey.png',
  verticalDark: '/logo/Dikey_beyaz.png',
} as const

export const PLATFORM_ADMIN_EMAIL = 'admin@codexfix.com'

export function isPlatformAdminUser(
  user: Pick<TenantUser, 'id' | 'email'> | null | undefined,
): boolean {
  if (!user) return false
  return user.id === 1 || user.email.trim().toLowerCase() === PLATFORM_ADMIN_EMAIL
}

export function platformHorizontalLogo(isDark: boolean): string {
  return isDark ? PLATFORM_LOGO.horizontalDark : PLATFORM_LOGO.horizontalLight
}

/** Göreli /storage yollarını API origin’e bağlar. */
export function resolveAdminMediaUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null
  const trimmed = url.trim()
  if (
    /^https?:\/\//i.test(trimmed) ||
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:') ||
    trimmed.startsWith('/logo/')
  ) {
    return trimmed
  }

  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`
  if (/^https?:\/\//i.test(API_BASE)) {
    return `${API_BASE.replace(/\/api\/v1\/?$/i, '')}${path}`
  }

  return path
}

export function resolveAdminAvatarSrc(user: TenantUser | null | undefined): string | null {
  if (!user) return null
  if (isPlatformAdminUser(user)) return PLATFORM_LOGO.avatar

  const raw =
    user.avatar?.trim() ||
    user.information?.profile_picture?.trim() ||
    null

  return resolveAdminMediaUrl(raw)
}
